import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import './DeleteConfirmModal.css';

const DeleteConfirmModal = ({ reel, onConfirm, onCancel }) => {
    return (
        <div className="reels-delete-modal">
            <div className="reels-delete-content">
                <div className="reels-delete-header">
                    <h3>Eliminar Historia</h3>
                </div>

                <div className="reels-delete-body">
                    <div className="reels-delete-preview">
                        <img
                            src={reel.thumbnailUrl || '/logo192.png'}
                            alt="Vista previa"
                            className="reels-delete-thumbnail"
                            onError={(e) => {
                                e.target.src = '/logo192.png';
                            }}
                        />
                    </div>

                    <div className="reels-delete-message">
                        <p><strong>¿Estás seguro que quieres eliminar esta historia?</strong></p>
                        <p>Esta acción no se puede deshacer. La historia será eliminada permanentemente.</p>

                        <div className="reels-delete-info">
                            <span>
                                <FontAwesomeIcon icon={faClock} /> {reel.duration || 0}s de duración
                            </span>
                        </div>
                    </div>
                </div>

                <div className="reels-delete-actions">
                    <button
                        className="reels-btn-cancel"
                        onClick={onCancel}
                    >
                        Cancelar
                    </button>
                    <button
                        className="reels-btn-delete"
                        onClick={onConfirm}
                    >
                        Eliminar Historia
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmModal;
